import { render } from "./AppInfoDialog.vue?vue&type=template&id=0d2fc726"
import script from "./AppInfoDialog.vue?vue&type=script&lang=js"
export * from "./AppInfoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__